<png-footer
  [startYear]="2019"
  contactUrl="https://www.precisely.com/contact"
  legalUrl="https://www.precisely.com/legal"
></png-footer>
